import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import {
  Checkbox,
  // Modal,
  Space,
  Spin,
  Switch,
  Table,
  Tag,
  Typography,
  Upload,
} from "antd";
import { EmailIcon, PhoneIcon, UploadAvatarIcon, UserIcon } from "assets/icons";
import { OPT_TYPE, PATTERNS, USER_TYPE } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import {
  doAddCustomerNotInBroadcastList,
  doGetBroadcastListNotIn,
  doGetBroadcastListPage,
} from "stores/slices/broadcastList";
import {
  doCreateCustomer,
  doGetCustomerDetail,
  doUpdateCustomer,
  doUpdateOptInCustomer,
  fecthCustomerDetail,
} from "stores/slices/customer";
import { doGetAllCustomField } from "stores/slices/customField";
import { setIsRefresh } from "stores/slices/layout";
import { doUploadAvatar } from "stores/slices/upload";
import { doGetWorkspacePage, WorkspaceInfo } from "stores/slices/workspace";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";

import TagRecipient from "../broadcast/tagRecipient";

// import SelectMultiple from "components/inputs/selectSearchMultiple";
import styles from "../../styles.module.scss";

// const { confirm } = Modal;
const CustomerForm = forwardRef(function CustomerForm(props, ref) {
  const {
    customerSelected,
    setIsOpenCustomerForm,
    setCustomerSelected,
    broadcastListId,
    customFields,
    isView,
    onChangeViewFrm,
    userType,
    workspaceObj,
    broadcastListObj,
    // setInitialValues,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const currentValues = useRef({});
  // const currentListBroadcastOpt = useRef([]);

  const [avatar, setAvatar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [customerInputItems, setCustomerInputItems] = useState([]);
  const [customFieldInputItems, setCustomFieldInputItems] = useState([]);
  const [customerDetail, setCustomerDetail] = useState();
  const [listAllBroadcastList, setListAllBroadcastList] = useState([]);
  const [totalBroadcastListPages, setTotalBroadcastListPages] = useState(0);
  const [broadcastListQueries, setBroadcastListQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [broadcastListOption, setOptionBroadcastList] = useState([]);
  const [loadingBroadcastList, setLoadingBroadcastList] = useState(false);

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspaceQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [loadingWorkspaceList, setLoadingWorkspaceList] = useState(false);

  const getCustomerDetail = useSelector(fecthCustomerDetail);
  const workspaceInfo = useSelector(WorkspaceInfo);
  const [listCustomField, setListCustomField] = useState([]);
  const [listBroadcastOpt, setListBroadcastOpt] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [listBroadcastListNotIn, setListBroadcastListNotIn] = useState([]);
  const [listAllNotIn, setListAllNotIn] = useState([]);
  const [loadingBroadCastListNotIn, setLoadingBroadCastListNotIn] =
    useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [broadcastListNotInQueries, setBroadcastListNotInQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [numberPhoneChange, setChangeValueNumber] = useState();
  const [addNewBroadcastList, setAddNewBroadcastList] = useState([]);
  // const [currentValues, setCurrentValues] = useState({});
  const [currentListBroadcastOpt, setCurrentListBroadcastOpt] = useState([]);
  // const [currentProfileImage, setCurrentProfileImage] = useState("");

  useImperativeHandle(ref, () => ({
    handleConfirmUnSave: () => {
      // handleConfirmUnSave();
    },
  }));

  // const confirmUnSave = async () => {
  //   await confirm({
  //     title: t("customer.unsavedChange"),
  //     icon: <ExclamationCircleOutlined />,
  //     content: t("customer.unsavedChangeMsg"),
  //     okText: t("button.save"),
  //     cancelText: t("button.cancel"),
  //     onOk: async () => {
  //       await handleSubmit();
  //       await setIsOpenCustomerForm(false);
  //     },
  //     onCancel() {
  //       setIsOpenCustomerForm(false);
  //     },
  //   });
  // };

  useEffect(() => {
    if (userType && userType === USER_TYPE.SUPER_ADMIN) {
      if (workspaceObj) {
        setOptionWorkspace([
          {
            id: workspaceObj?.workspcaeId,
            name: `${workspaceObj?.workspaceName}`,
          },
        ]);
        // setFieldValue("workspaceId", workspaceObj?.worksapceId);
      } else {
        fetchListWorkspace({
          pageNumber: 1,
          pageSize: 10,
          statuses: ["ACTIVE"],
          sortFieldWorkspace: "createdTime",
        });
      }
    }
  }, [userType, workspaceObj]);

  useEffect(() => {
    if (customerSelected) {
      const request = {
        pageSize: 10,
        pageNumber: 1,
        customerId: customerSelected.customerId,
      };
      const params = {
        pageNumber: 1,
        pageSize: 10,
      };
      if (userType && userType === USER_TYPE.SUPER_ADMIN) {
        request["workspaceId"] = customerSelected.workspace.id;
        params["workspaceId"] = customerSelected?.workspace?.id;
      }
      fetchBroadcastListNotIn(request);
      fetchListBroadcastList(params);
    }
  }, [customerSelected]);

  const fetchBroadcastListNotIn = async request => {
    let newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      customerId: customerSelected.customerId,
    };
    if (request.workspaceId || userType === USER_TYPE.SUPER_ADMIN) {
      newRequest["workspaceId"] =
        request.workspaceId || customerSelected.workspace.id;
    }
    if (request.isReset) {
      setListBroadcastListNotIn([]);
      setListAllNotIn([]);
      delete newRequest.isReset;
    }
    if (totalPages > 0 && totalPages < newRequest.pageNumber) {
      return;
    }
    setLoadingBroadCastListNotIn(true);
    const { payload } = await dispatch(doGetBroadcastListNotIn(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListBroadcastListNotIn(removeDuplicates([...payload.content]));
      } else {
        setListBroadcastListNotIn(
          removeDuplicates([...listBroadcastListNotIn, ...payload.content])
        );
      }
      setTotalPages(payload.totalPages);
      setBroadcastListNotInQueries(newRequest);
    }
    setLoadingBroadCastListNotIn(false);
  };

  useEffect(() => {
    if (listBroadcastListNotIn && listBroadcastListNotIn?.length > 0) {
      const newOptions = listBroadcastListNotIn.map(item => {
        return {
          id: item.externalId,
          label: `${item.name}`,
        };
      });
      setListAllNotIn(newOptions);
    } else {
      setListAllNotIn([]);
    }
  }, [listBroadcastListNotIn]);

  const handleScrollBroadcastListNotIn = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      broadcastListNotInQueries.pageNumber <= totalPages &&
      !loadingBroadCastListNotIn
    ) {
      fetchBroadcastListNotIn({
        ...broadcastListNotInQueries,
        pageNumber: broadcastListNotInQueries.pageNumber + 1,
      });
    }
  };

  const handleSearchKeyBroadcastListNotIn = key => {
    if (key) {
      fetchBroadcastListNotIn({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        searchKeyName: key,
      });
    } else {
      fetchBroadcastListNotIn({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    }
  };

  const fetchListBroadcastList = async request => {
    const newRequest = {
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
    };
    if (request.workspaceId) {
      newRequest["workspaceId"] = request.workspaceId;
    }
    if (request.isReset) {
      setListAllBroadcastList([]);
      setOptionBroadcastList([]);
      delete newRequest.isReset;
    }
    if (
      totalBroadcastListPages > 0 &&
      totalBroadcastListPages < newRequest.pageNumber
    ) {
      return;
    }
    setLoadingBroadcastList(true);
    const { payload } = await dispatch(doGetBroadcastListPage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllBroadcastList(removeDuplicates([...payload.content]));
      } else {
        setListAllBroadcastList(
          removeDuplicates([...listAllBroadcastList, ...payload.content])
        );
      }
      setTotalBroadcastListPages(payload.totalPages);
      setBroadcastListQueries(newRequest);
    }
    setLoadingBroadcastList(false);
  };

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingWorkspaceList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingWorkspaceList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };
  const removeDuplicatesCustomFields = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.key === ele.key)
    );
  };

  useEffect(() => {
    if (listAllBroadcastList && listAllBroadcastList?.length > 0) {
      const newOptions = listAllBroadcastList.map(item => {
        return {
          id: item.id,
          name: `${item.name}`,
        };
      });
      setOptionBroadcastList(newOptions);
    } else {
      if (broadcastListObj) {
        setOptionBroadcastList([
          {
            id: broadcastListObj?.broadcastListId,
            name: broadcastListObj?.broadcastListName,
          },
        ]);
      } else {
        setOptionBroadcastList([]);
      }
    }
  }, [listAllBroadcastList, broadcastListObj]);

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          id: item.id,
          name: `${item.name}`,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      if (workspaceObj) {
        setOptionWorkspace([
          {
            id: workspaceObj?.workspaceId,
            name: `${workspaceObj?.workspaceName}`,
          },
        ]);
      } else {
        setOptionWorkspace([]);
      }
    }
  }, [listAllWorkspace, workspaceObj]);

  const handleScrollBroadcastList = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      broadcastListQueries.pageNumber <= totalBroadcastListPages &&
      !loadingBroadcastList
    ) {
      fetchListBroadcastList({
        ...broadcastListQueries,
        pageNumber: broadcastListQueries.pageNumber + 1,
      });
    }
  };

  const handleSearchKeyBroadcastList = key => {
    if (key) {
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        searchKeyName: key,
      });
    } else {
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    }
  };

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspaceQueries.pageNumber <= totalWorkspacePages &&
      !loadingWorkspaceList
    ) {
      fetchListWorkspace({
        ...workspaceQueries,
        pageNumber: workspaceQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  useEffect(() => {
    if (numberPhoneChange) {
      setFieldValue("phoneNumber", numberPhoneChange);
    }
  }, [numberPhoneChange]);

  const validationSchema = Yup.object().shape({
    workspaceId:
      userType === USER_TYPE.SUPER_ADMIN && !customerSelected
        ? Yup.string().required()
        : Yup.string().nullable(),
    broadcastListId:
      userType === USER_TYPE.SUPER_ADMIN && !customerSelected
        ? Yup.string().required()
        : Yup.string().nullable(),
    firstName: Yup.string().max(255, "validate.max_length_255").nullable(),
    lastName: Yup.string().max(255, "validate.max_length_255").nullable(),
    email: Yup.string()
      .trim()
      .max(255, "validate.max_length_255")
      .email("validate.email.invalid"),
    phoneNumber: Yup.string()
      .trim()
      .required("validate.required")
      .test("phoneNumber", "validate.phoneNumber.invalid", value => {
        let phoneNumber = value;
        if (
          PATTERNS.PHONE_NUMBER_LENGTH.test(value) &&
          PATTERNS.ZERO_ONLY.test(value)
        ) {
          const validPhoneNumber = parsePhoneNumber(phoneNumber);
          if (validPhoneNumber && validPhoneNumber.isPossible()) {
            if (validPhoneNumber.country && validPhoneNumber.isValid()) {
              const newValue = validPhoneNumber.formatInternational();
              setChangeValueNumber(
                newValue.toString().replaceAll(" ", "").replaceAll("+", "")
              );
              return true;
            }
          } else {
            phoneNumber = value.includes("+") ? value : `+${phoneNumber}`;
            const validContactNumber = parsePhoneNumber(phoneNumber);
            if (validContactNumber && validContactNumber.isPossible()) {
              if (validContactNumber.country && validContactNumber.isValid()) {
                const newValue = validContactNumber.formatInternational();
                setChangeValueNumber(
                  newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                );
                return true;
              } else {
                setChangeValueNumber(value);
                return false;
              }
            } else {
              const validPhoneNumber2 = parsePhoneNumber(value, "AU");
              if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
                if (validPhoneNumber2.country && validPhoneNumber2.isValid()) {
                  const newValue = validPhoneNumber2.formatInternational();
                  setChangeValueNumber(
                    newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                  );
                  return true;
                } else {
                  setChangeValueNumber(value);
                  return false;
                }
              } else {
                const validContactNumber2 = parsePhoneNumber(phoneNumber, "AU");
                if (validContactNumber2 && validContactNumber2.isPossible()) {
                  if (
                    validContactNumber2.country &&
                    validContactNumber2.isValid()
                  ) {
                    const newValue = validContactNumber2.formatInternational();
                    setChangeValueNumber(
                      newValue
                        .toString()
                        .replaceAll(" ", "")
                        .replaceAll("+", "")
                    );
                    return true;
                  } else {
                    setChangeValueNumber(value);
                    return false;
                  }
                }
              }
            }
          }
        } else {
          setChangeValueNumber(value);
          return false;
        }
      })
      .matches(PATTERNS.PHONE_NUMBER, {
        message: "validate.phoneNumber.invalid",
      })
      .min(6, "validate.min_length_6")
      .max(45, "validate.max_length_45"),
    facebook: Yup.string().max(45, "validate.max_length_45"),
    instagram: Yup.string().max(45, "validate.max_length_45"),
    twitter: Yup.string().max(45, "validate.max_length_45"),
    snapchat: Yup.string().max(45, "validate.max_length_45"),
  });

  const onSubmit = async data => {
    setLoading(true);
    let request = {
      firstName: data.firstName ? data.firstName.trim() : "",
      lastName: data.lastName ? data.lastName.trim() : "",
      profileImage: avatar || "",
      phoneNumber: data.phoneNumber.trim(),
      email: data.email ? data.email.trim() : "",
      facebook: data.facebook ? data.facebook.trim() : "",
      instagram: data.instagram ? data.instagram.trim() : "",
      twitter: data.twitter ? data.twitter.trim() : "",
      snapchat: data.snapchat ? data.snapchat.trim() : "",
      optin: data.status === OPT_TYPE.OPTED_IN, // true
      createCustomerHasCustomFieldRequests: [],
    };

    if (customFields) {
      customFields.forEach(item => {
        if (data[item.id]) {
          request.createCustomerHasCustomFieldRequests.push({
            customFieldId: item.id,
            value: data[item.id] ? data[item.id].trim() : "",
          });
        }
      });
    }

    if (customerSelected) {
      const result = await dispatch(
        doUpdateCustomer({
          data: {
            ...request,
            workspaceId:
              userType === USER_TYPE.SUPER_ADMIN
                ? customerSelected.workspace.id
                : "",
          },
          id: customerSelected.customerId,
          broadcastListId: broadcastListId,
        })
      );
      if (result && result.payload.status === 200) {
        setIsOpenCustomerForm(false);
        dispatch(doGetCustomerDetail({ id: result.payload.data.customerId }));
      }

      if (data.list && data.list.length > 0) {
        await dispatch(
          doAddCustomerNotInBroadcastList({
            customerId: customerSelected.customerId,
            broadcastListIds: data.list,
          })
        );
      }

      if (listBroadcastOpt && listBroadcastOpt.length > 0) {
        let newList = [...listBroadcastOpt];
        newList = newList.map(item => {
          return {
            broadcastListId: item.broadcastListId,
            optin: item.optin,
          };
        });

        await dispatch(
          doUpdateOptInCustomer({
            id: customerSelected.customerId,
            data: {
              workspaceId:
                data.workspaceId ||
                customerSelected?.workspace?.id ||
                workspaceInfo.id,
              listCustomerOptinRequests: newList,
            },
          })
        );
      }

      if (result && result.payload.status === 200) {
        setIsOpenCustomerForm(false);

        dispatch(setIsRefresh(uuid()));
      }
    } else {
      const result = await dispatch(
        doCreateCustomer(
          userType === USER_TYPE.SUPER_ADMIN
            ? {
                workspaceId: data.workspaceId,
                broadcastListId: data.broadcastListId,
                createCustomerAndContactRequests: [{ ...request }],
              }
            : {
                broadcastListId: broadcastListId,
                createCustomerAndContactRequests: [{ ...request }],
              }
        )
      );
      if (result && result.payload.status === 200) {
        setIsOpenCustomerForm(false);
        dispatch(setIsRefresh(uuid()));
      }
    }
    setLoading(false);
  };

  const handleForm = useFormik({
    initialValues: {
      workspaceId: "",
      broadcastListId: "",
      profileImage: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      facebook: "",
      instagram: "",
      twitter: "",
      snapchat: "",
      status: OPT_TYPE.OPTED_IN,
      list: [],
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });

  const { values, setFieldValue, handleSubmit, setValues } = handleForm;

  // const handleConfirmUnSave = () => {
  //   const isArrayEqual = areArraysEqual(
  //     currentListBroadcastOpt,
  //     listBroadcastOpt
  //   );
  //   if (
  //     JSON.stringify(currentValues) !== JSON.stringify(values) ||
  //     JSON.stringify(currentValues?.profileImage) !==
  //       JSON.stringify(currentProfileImage) ||
  //     !isArrayEqual
  //   ) {
  //     confirmUnSave();
  //   } else {
  //     setIsOpenCustomerForm(false);
  //   }
  // };

  // const areArraysEqual = (arr1, arr2) => {
  //   if (arr1?.length > 0 && arr2?.length > 0) {
  //     if (arr1.length !== arr2.length) return false;

  //     return arr1.every((item, index) => {
  //       const item2 = arr2[index];
  //       return (
  //         item.broadcastListId === item2.broadcastListId &&
  //         item.name === item2.name &&
  //         item.optin === item2.optin &&
  //         item.default === item2.default
  //       );
  //     });
  //   }
  // };

  const beforeUploadImg = async file => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      toast.error("You can only upload JPG/JPEG/PNG file!");
      console.log("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      toast.error("Image must smaller than 5MB!");
      console.log("Image must smaller than 5MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUploadImg = async info => {
    setIsUploading(true);
    const request = {
      cannedAccessControlList: "PublicRead",
      uploadFileType: "UPLOAD_AVATAR",
      file: info.file,
    };
    const result = await dispatch(doUploadAvatar(request));
    if (result && result.payload.status === 200) {
      setAvatar(result.payload.data);
    }
    setIsUploading(false);
  };

  const handleInputField = customFields => {
    let customerInput = [];
    if (!customerSelected) {
      customerInput = [
        {
          type: "text",
          key: "firstName",
          label: t("customer.firstName"),
          placeholder: "customer.firstName",
          icon: <UserIcon />,
          span: 12,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "lastName",
          label: t("customer.lastName"),
          placeholder: "customer.lastName",
          icon: <UserIcon />,
          span: 12,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "phoneNumber",
          label: t("customer.mobileNumber"),
          placeholder: "text.userPhoneNumber",
          icon: <PhoneIcon />,
          span: 24,
          style: {
            marginBottom: 16,
          },
          required: true,
          disabled: isView,
        },
        {
          type: "text",
          key: "email",
          label: t("label.email"),
          placeholder: "label.email",
          icon: <EmailIcon />,
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "facebook",
          label: t("customer.facebookUrl"),
          placeholder: "customer.facebookUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "instagram",
          label: t("customer.instagramUrl"),
          placeholder: "customer.instagramUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "twitter",
          label: t("customer.twitterUrl"),
          placeholder: "customer.twitterUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "snapchat",
          label: t("customer.snapchat"),
          placeholder: "customer.snapchat",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
      ];
    } else {
      customerInput = [
        {
          type: "text",
          key: "firstName",
          label: t("customer.firstName"),
          placeholder: "customer.firstName",
          icon: <UserIcon />,
          span: 12,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "lastName",
          label: t("customer.lastName"),
          placeholder: "customer.lastName",
          icon: <UserIcon />,
          span: 12,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "phoneNumber",
          label: t("customer.mobileNumber"),
          placeholder: "text.userPhoneNumber",
          icon: <PhoneIcon />,
          span: 24,
          style: {
            marginBottom: 16,
          },
          required: true,
          disabled: isView,
        },
        {
          type: "text",
          key: "email",
          label: t("label.email"),
          placeholder: "label.email",
          icon: <EmailIcon />,
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "facebook",
          label: t("customer.facebookUrl"),
          placeholder: "customer.facebookUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "instagram",
          label: t("customer.instagramUrl"),
          placeholder: "customer.instagramUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "twitter",
          label: t("customer.twitterUrl"),
          placeholder: "customer.twitterUrl",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "text",
          key: "snapchat",
          label: t("customer.snapchat"),
          placeholder: "customer.snapchat",
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        },
        {
          type: "tags",
          key: "list",
          label: t("label.broadcastList"),
          value: [],
          options: listAllNotIn,
          selectKeyValue: "id",
          placeholder: t("label.broadcastList"),
          tagRender: TagRecipient,
          config: {
            disabled: isView,
            loading: !isView && loadingBroadCastListNotIn,
            mode: "tags",
            style: {
              height: "auto",
              fontWeight: 400,
            },
            handleScroll: handleScrollBroadcastListNotIn,
            handleSearchKey: handleSearchKeyBroadcastListNotIn,
          },
        },
      ];
    }

    if (userType === USER_TYPE.SUPER_ADMIN) {
      customerInput = [
        {
          type: "select-search",
          key: "workspaceId",
          label: "label.workspace",
          placeholder: "label.workspace",
          value: "",
          options: workspaceOption,
          selectKeyValue: "id",
          required: true,
          config: {
            disabled: isView || workspaceObj,
            loading: loadingWorkspaceList,
            style: {
              fontSize: "14px",
            },
            handleScroll: handleScrollWorkspace,
            handleSearchKey: handleSearchKeyWorkspace,
          },
        },
        {
          type: "select-search",
          key: "broadcastListId",
          label: "label.broadcastList",
          placeholder: "label.broadcastList",
          value: "",
          options: broadcastListOption,
          selectKeyValue: "id",
          required: true,
          config: {
            disabled: values.worksapceId || isView || broadcastListObj,
            loading: loadingBroadcastList,
            style: {
              fontSize: "14px",
            },
            handleScroll: handleScrollBroadcastList,
            handleSearchKey: handleSearchKeyBroadcastList,
          },
        },
        ...customerInput,
      ];
    }
    if (userType === USER_TYPE.USER) {
      customerInput.filter(
        item =>
          item.key !== "workspaceId" && item.key !== "broadcastListId" && item
      );
    }

    // remove status from arr
    if (!customerSelected) {
      customerInput.splice(
        customerInput.findIndex(item => item.key === "status"),
        1
      );
    }
    if (customerSelected && userType === USER_TYPE.SUPER_ADMIN) {
      customerInput = customerInput.filter(
        item =>
          item.key !== "workspaceId" &&
          item.key !== "list" &&
          item.key !== "broadcastListId" &&
          item
      );
    }

    setCustomerInputItems(customerInput);

    let customFieldInput = [];
    if (customFields && customFields.length > 0) {
      customFields.forEach(item => {
        customFieldInput.push({
          type: "text",
          key: item.id,
          label: item.name,
          placeholder: item.name,
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        });
      });
    }

    if (listCustomField.length > 0) {
      listCustomField.forEach(item => {
        customFieldInput.push({
          type: "text",
          key: item.id,
          label: item.name,
          placeholder: item.name,
          span: 24,
          style: {
            marginBottom: 16,
          },
          disabled: isView,
        });
      });
    } else {
      setListCustomField([]);
    }
    setCustomFieldInputItems(
      removeDuplicatesCustomFields([...customFieldInput])
    );
  };

  useEffect(() => {
    if (customerSelected && getCustomerDetail) {
      setCustomerDetail(getCustomerDetail);
      if (getCustomerDetail.broadcastLists) {
        setIsLoading(true);
        const newList = getCustomerDetail.broadcastLists.map(item => {
          return {
            broadcastListId: item.id,
            name: item.name,
            optin: item.broadcastListCustomer.optin,
            default: item.broadcastListCustomer.optin,
          };
        });
        if (newList.find(item => item.default === true)) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
        setListBroadcastOpt(newList);
        currentListBroadcastOpt.current = newList;
        setCurrentListBroadcastOpt(newList);
        setIsLoading(false);
      }
    }
  }, [getCustomerDetail]);

  useEffect(() => {
    if (customerDetail) {
      let values = {
        workspaceId: workspaceObj?.workspaceId || "",
        firstName: customerDetail?.firstName || "",
        lastName: customerDetail?.lastName || "",
        profileImage: customerDetail?.profileImage || "",
        phoneNumber: customerDetail?.contact?.phoneNumber || "",
        email: customerDetail?.contact?.email || "",
        facebook: customerDetail?.contact?.facebook || "",
        instagram: customerDetail?.contact?.instagram || "",
        twitter: customerDetail?.contact?.twitter || "",
        snapchat: customerDetail?.contact?.snapchat || "",
        status: customerDetail?.broadcastListCustomer?.optin
          ? OPT_TYPE.OPTED_IN
          : OPT_TYPE.OPTED_OUT || "",
      };
      if (customFields) {
        customFields.forEach(item => {
          let index = customerDetail.customerHasCustomFields?.findIndex(
            i => i.customFieldId === item.id
          );
          values[item.id] =
            (index && index !== -1) || index === 0
              ? customerDetail.customerHasCustomFields[index].value
              : "";
        });
      }
      setValues(values);
      // setCurrentValues(values);
      // setCurrentProfileImage(customerDetail?.profileImage);
      // Set initial values to compare the change
    }
  }, [customerDetail, workspaceObj]);

  useEffect(() => {
    setFieldValue("profileImage", avatar);
  }, [avatar]);

  useEffect(() => {
    if (workspaceObj && broadcastListObj) {
      setValues({
        ...values,
        workspaceId: workspaceObj?.workspaceId,
        broadcastListId: broadcastListObj?.broadcastListId,
      });
    }
  }, [workspaceObj, broadcastListObj]);

  useEffect(() => {
    handleInputField(customFields);
  }, [isView, customFields, workspaceOption, broadcastListOption, userType]);

  const handleGetCustomerDetail = async id => {
    await dispatch(
      doGetCustomerDetail({ id: id, broadcastListId: broadcastListId })
    );
  };

  useEffect(() => {
    if (customerSelected && customerSelected.customerId) {
      handleGetCustomerDetail(customerSelected.customerId);
      if (userType === USER_TYPE.SUPER_ADMIN) {
        getListCustomField(customerSelected.workspace?.id);
      }
    }
  }, []);

  useEffect(() => {
    if (broadcastListObj && workspaceObj) {
      getListCustomField(workspaceObj?.workspaceId);
    }
  }, [broadcastListObj, workspaceObj]);

  const getListCustomField = async workspaceId => {
    const result = await dispatch(doGetAllCustomField(workspaceId));
    if (result) {
      setListCustomField(result.payload);
    }
  };

  const handleOnChange = (key, value) => {
    setFieldValue(key, value);
    if (key === "workspaceId") {
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        workspaceId: value,
        isReset: true,
      });
      if (value) {
        getListCustomField(value);
      } else {
        setListCustomField([]);
      }
    }
    if (key === "list") {
      if (addNewBroadcastList.length < value.length) {
        const newBroadcastList = listAllNotIn.find(
          item => item.id === value[value.length - 1]
        );
        if (newBroadcastList) {
          const isOldBroadcastList = listBroadcastOpt.find(
            item => item.broadcastListId === newBroadcastList.id
          );
          if (!isOldBroadcastList) {
            const newOption = {
              broadcastListId: newBroadcastList.id,
              default: true,
              name: newBroadcastList.label,
              optin: true,
            };
            setListBroadcastOpt([newOption, ...listBroadcastOpt]);
            setAddNewBroadcastList(value);
            setIsDisabled(false);
          }
        }
      } else {
        const newList = addNewBroadcastList
          .map(bl => {
            if (!value.find(item => item === bl)) {
              return bl;
            }
          })
          .filter(item => item !== undefined && item);
        const checkList = listBroadcastOpt
          .map(lbo => {
            if (lbo.broadcastListId !== newList[0]) {
              return lbo;
            }
          })
          .filter(item => item !== undefined && item);
        setListBroadcastOpt([...checkList]);
        setAddNewBroadcastList(value);
      }
    }
  };

  const handleChangeStatus = (id, value) => {
    let newList = [...listBroadcastOpt];
    newList = newList.map(item => {
      if (item.broadcastListId === id) {
        // item.optin = value;
        return {
          broadcastListId: item.broadcastListId,
          name: item.name,
          optin: value,
          // optin: item.optin,
          default: item.default,
        };
      } else {
        return {
          broadcastListId: item.broadcastListId,
          name: item.name,
          optin: item.optin,
          default: item.default,
        };
      }
    });

    if (newList.find(item => item.optin === true) && isDisabled) {
      setIsDisabled(false);
    }
    if (!newList.find(item => item.optin === true) && !isDisabled) {
      setIsDisabled(true);
    }
    setListBroadcastOpt(newList);
  };

  const handleChangeAll = event => {
    let newList = listBroadcastOpt;
    setIsDisabled(event.target.checked);
    if (event.target.checked) {
      newList = newList.map(item => {
        return {
          broadcastListId: item.broadcastListId,
          name: item.name,
          optin: false,
          default: item.default,
        };
      });
    } else {
      newList = newList.map(item => {
        return {
          broadcastListId: item.broadcastListId,
          name: item.name,
          optin: true,
          default: item.default,
        };
      });
    }
    setListBroadcastOpt(newList);
  };

  const handleTitleActions = () => (
    <Space>
      <Checkbox
        onChange={handleChangeAll}
        // disabled={isDisabled}
        defaultChecked={isDisabled ? true : false}
        checked={isDisabled ? true : false}
      />
      {t("customer.status")}
    </Space>
  );

  useEffect(() => {
    if (listBroadcastOpt && listBroadcastOpt.length > 0) {
      if (listBroadcastOpt.find(item => item.optin === true) && isDisabled) {
        setIsDisabled(false);
      }
      if (!listBroadcastOpt.find(item => item.optin === true) && !isDisabled) {
        setIsDisabled(true);
      }
      let cols = [
        {
          title: t("customer.broadcastListName"),
          width: 120,
          dataIndex: "broadcastListName",
          key: "broadcastListName",
          ellipsis: {
            showTitle: true,
          },
          render: (_, record) => <>{record.name}</>,
        },
        {
          title: isView ? t("customer.status") : handleTitleActions,
          width: 60,
          dataIndex: "status",
          key: "status",
          render: (_, record) =>
            isView ? (
              <Tag
                color={record?.optin ? "#0E9154" : "#A9122B"}
                bordered={false}
              >
                {record?.optin ? t("customer.optedIn") : t("customer.optedOut")}
              </Tag>
            ) : (
              <Switch
                checkedChildren={t("customer.optedIn")}
                unCheckedChildren={t("customer.optedOut")}
                // defaultChecked={record?.optin}
                value={record?.optin}
                onChange={checked =>
                  handleChangeStatus(record?.broadcastListId, checked)
                }
                className={
                  record?.optin ? styles.switchChecked : styles.switchUnChecked
                }
              />
            ),
        },
      ];
      setColumns(cols);
    }
    // if (!isView) {
    //   cols = [
    //     ...cols,
    //     {
    //       title: handleTitleActions,
    //       width: 120,
    //       dataIndex: "optin",
    //       key: "optin",
    //       ellipsis: {
    //         showTitle: true,
    //       },
    //       render: (_, record) => (
    //         <Space>
    //           <Checkbox
    //             key={record.broadcastListId}
    //             checked={!record?.optin}
    //             // disabled={record?.default === false}
    //             onChange={e =>
    //               handleChangeStatus(record?.broadcastListId, e.target.checked)
    //             }
    //           />
    //         </Space>
    //       ),
    //     },
    //   ];
    // }
  }, [listBroadcastOpt, isView, isDisabled]);

  return (
    <>
      <div className={styles.customerFormContainer}>
        {/* <Space direction="vertical">
          <Typography>{t("customer.profileImage")}</Typography>
          <Upload
            disabled={isView}
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            multiple={true}
            beforeUpload={beforeUploadImg}
            // onChange={handleUploadImg}
            customRequest={handleUploadImg}
            accept={".png, .jpg, .jpeg"}
          >
            {isUploading ? (
              <div>
                <div className={styles.uploadContainer}>
                  <div className={styles.uploadAvatarIcon}>
                    <UploadAvatarIcon />
                  </div>
                </div>
                <Typography
                  style={{
                    marginTop: 8,
                    color: "#626576",
                  }}
                >
                  {"Uploading..."}
                </Typography>
              </div>
            ) : avatar || (customerDetail && customerDetail.profileImage) ? (
              <div
                style={{
                  width: "100%",
                  maxHeight: "100px",
                }}
              >
                <img
                  src={
                    avatar
                      ? avatar
                      : customerDetail && customerDetail.profileImage
                      ? customerDetail.profileImage
                      : avatar
                  }
                  alt="avatar"
                  style={{ width: "90px", height: "90px", objectFit: "cover" }}
                />
              </div>
            ) : (
              !isUploading && (
                <div>
                  <div className={styles.uploadContainer}>
                    <div className={styles.uploadAvatarIcon}>
                      <UploadAvatarIcon />
                    </div>
                  </div>
                  <Typography
                    style={{
                      marginTop: 8,
                      color: "#626576",
                    }}
                  >
                    {t("text.uploadAvatarMsg")}
                  </Typography>
                </div>
              )
            )}
          </Upload>
        </Space> */}
        <Space direction="vertical">
          <Typography>{t("customer.profileImage")}</Typography>
          <Upload
            disabled={isView}
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            multiple={true}
            beforeUpload={beforeUploadImg}
            // onChange={handleUploadImg}
            customRequest={handleUploadImg}
            accept={".png, .jpg, .jpeg"}
          >
            {isUploading ? (
              <div>
                <div className={styles.uploadContainer}>
                  <div className={styles.uploadAvatarIcon}>
                    <UploadAvatarIcon />
                  </div>
                </div>
                <Typography
                  style={{
                    marginTop: 8,
                    color: "#626576",
                  }}
                >
                  {"Uploading..."}
                </Typography>
              </div>
            ) : avatar || (values && values.profileImage) ? (
              <div
                style={{
                  width: "100%",
                  maxHeight: "100px",
                }}
              >
                <img
                  src={
                    avatar
                      ? avatar
                      : values && values.profileImage
                      ? values.profileImage
                      : avatar
                  }
                  alt="avatar"
                  style={{ width: "90px", height: "90px", objectFit: "cover" }}
                />
              </div>
            ) : (
              !isUploading && (
                <div>
                  <div className={styles.uploadContainer}>
                    <div className={styles.uploadAvatarIcon}>
                      <UploadAvatarIcon />
                    </div>
                  </div>
                  <Typography
                    style={{
                      marginTop: 8,
                      color: "#626576",
                    }}
                  >
                    {t("text.uploadAvatarMsg")}
                  </Typography>
                </div>
              )
            )}
          </Upload>
        </Space>
        <FormInput
          items={customerInputItems
            .map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })
            .filter(
              item =>
                item.key !== "broadcaslistId" && item.key !== "list" && item
            )}
          form={handleForm}
          onChange={handleOnChange}
          layout={"vertical"}
        />

        {customerDetail && (
          <>
            <Typography
              className={styles.labelGroupHeader}
              style={{
                marginBottom: 16,
              }}
            >
              {t("customer.broadcastListIncludes")}
            </Typography>
            <Space style={{ width: "100%" }} direction={"vertical"}>
              <div style={{ width: "100%" }}>
                <FormInput
                  items={customerInputItems
                    .map(item => {
                      item.label = t(item.label);
                      if (item.key) {
                        item.value = getIn(values, item.key);
                      }
                      return { ...item };
                    })
                    .filter(
                      item =>
                        (item.key === "broadcaslistId" ||
                          item.key === "list") &&
                        item
                    )}
                  form={handleForm}
                  onChange={handleOnChange}
                  layout={"vertical"}
                />
              </div>
              {customerDetail && customerDetail.broadcastLists ? (
                isLoading ? (
                  <Spin />
                ) : (
                  <React.Fragment>
                    <Table
                      columns={columns}
                      dataSource={listBroadcastOpt}
                      // onChange={handleTableChange}
                    />
                  </React.Fragment>
                )
              ) : (
                <></>
              )}
            </Space>
          </>
        )}
        {customFieldInputItems.length > 0 && (
          <Typography
            className={styles.labelGroupHeader}
            style={{ marginBottom: "12px" }}
          >
            {t("customer.customField")}
          </Typography>
        )}
        <FormInput
          items={customFieldInputItems.map(item => {
            if (userType === USER_TYPE.SUPER_ADMIN && customerSelected) {
              item.label = t(item.label);
              if (
                item.key &&
                item.key !== "workspaceId" &&
                item.key !== "broadcastListId"
              ) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            } else {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            }
          })}
          form={handleForm}
          onChange={setFieldValue}
          layout={"vertical"}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <AppButton
          label={t("label.cancel")}
          color={"grey"}
          loading={loading}
          type="button"
          onClick={() => {
            if (setCustomerSelected) {
              setCustomerSelected(null);
            }
            // handleConfirmUnSave();
            setIsOpenCustomerForm(false);
            setListBroadcastOpt([]);
          }}
          size={"minimum"}
          className={"cancelButton"}
        />
        {isView ? (
          <AppButton
            label={t("button.edit")}
            color={"blue"}
            loading={loading}
            type="primary"
            onClick={() => onChangeViewFrm(false)}
            size={"minimum"}
          />
        ) : (
          <AppButton
            label={t("label.save")}
            color={"blue"}
            loading={loading}
            type="submit"
            onClick={handleSubmit}
            size={"minimum"}
          />
        )}
      </div>
    </>
  );
});
export default CustomerForm;
